import { combineReducers } from 'redux';
let rootReducerMap = {};
export function combineRootReducers(appendReducers) {
    rootReducerMap = {
        ...rootReducerMap,
        ...appendReducers,
    };
    return rootReducerMap;
}
/**
 * Root reducer
 */
export const getRootReducer = () => combineReducers(rootReducerMap);
//# sourceMappingURL=reducer.js.map